
		<div>
			<gotosupport
				[@stateAnimation]="myStatusExp"
				[queryParams]="{value: siteUrl, typeFilter: 'site'}"
			>
				<i
					[style.color]="color"
					class="fa fa-info-circle"
					aria-hidden="true"
				></i>
			</gotosupport>
			&nbsp;
			<a
				target="_blank"
				rel="noreferrer"
				[href]="'http://' + siteUrl"
			>
				{{ siteUrl }}
			</a>
			&nbsp;
			<a
				*ngIf="siteInfoConfig.dashboardUrl"
				class=" ul-status ul-dashboard"
				[href]="siteInfoConfig.dashboardUrl"
				target="_blank"
			>
				<i class="fa fa-tachometer-alt" aria-hidden="true"></i>
			</a>
		</div>
	